import React, { useState, useRef, useEffect } from 'react';
import './Navbar.css';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../../assets/WAY-TRIX.png';

const Navbar = () => {
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const drawerRef = useRef(null);
  const [restoToken, setRestoToken] = useState(localStorage.getItem('restoToken') || '');

  useEffect(() => {
    const updateToken = () => setRestoToken(localStorage.getItem('restoToken') || '');
    window.addEventListener('storage', updateToken);
    window.addEventListener('authChange', updateToken);
    return () => {
      window.removeEventListener('storage', updateToken);
      window.removeEventListener('authChange', updateToken);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (drawerRef.current && !drawerRef.current.contains(event.target)) {
        setDrawerOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleMenuItemClick = (event) => {
    event.currentTarget.querySelector('.sub-menu').classList.toggle('show');
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo" style={{ cursor: 'pointer' }} onClick={() => navigate(restoToken ? '/' : '/RestoLogin')}>
          <img src={logo} alt="Waytrix Logo" style={{ height: '50px' }} />
        </div>
        {/* The drawer is fixed at right:-300px and only slides in via .open, so
            without this toggle nothing in the menu is reachable. The CSS for it
            already existed; the button itself was missing from the markup. */}
        <div
          className="navbar-toggle"
          onClick={(e) => { e.stopPropagation(); setDrawerOpen((open) => !open); }}
          role="button"
          tabIndex={0}
          aria-label={drawerOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={drawerOpen}
          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setDrawerOpen((open) => !open); }}
        >
          <div className="hamburger">
            <div className="linee" />
            <div className="linee" />
            <div className="linee" />
          </div>
        </div>
        {/* Navigating should dismiss the drawer, otherwise it stays open over
            the page the user just asked for. */}
        <div
          ref={drawerRef}
          className={`drawer ${drawerOpen ? 'open' : ''}`}
          onClick={(e) => { if (e.target.closest('a')) setDrawerOpen(false); }}
        >
          <ul className="drawer-menu">
            {!restoToken &&
              <Link className='Link' to="/RestoLogin">
                <li className="drawer-menu-item">
                  <span className="dropdown-toggle aTitle">Resto Login</span>
                </li>
              </Link>
            }
            {restoToken &&
              <li className="drawer-menu-item">
                <span className="dropdown-toggle aTitle" onClick={() => { localStorage.removeItem('restoToken'); sessionStorage.removeItem('restoDataPinToken'); window.location.href = '/RestoLogin'; }}>
                  Resto Logout
                </span>
              </li>
            }
            {/* Top-level rather than inside the Resto Account dropdown: that
                sub-menu is collapsed to max-height 0 until clicked, which hid
                this section entirely.

                One entry, not two. The wallet used to sit beside this as its
                own link, but the server gates both with the same PIN, so they
                were never separate sections — they are tabs of one now. */}
            {restoToken &&
              <Link className='Link' to="/CustomerData">
                <li className="drawer-menu-item">
                  <span className="dropdown-toggle aTitle">Customer Insights</span>
                </li>
              </Link>
            }
            {restoToken &&
              <li className="drawer-menu-item" onClick={handleMenuItemClick}>
                <span className="dropdown-toggle aTitle">Resto Account</span>
                <ul className="sub-menu">
                  <li className='aSubTitle'><Link className='Link' to="/AddMenu">Add Menu</Link></li>
                  <li className='aSubTitle'><Link className='Link' to="/MoreAnalytics">More Analytics</Link></li>
                  <li className='aSubTitle'><Link className='Link' to="/ViewTables">View Tables</Link></li>
                  <li className='aSubTitle'><Link className='Link' to="/GetWaiters">Assign Tables To Waiters</Link></li>
                  <li className='aSubTitle'><Link className='Link' to="/GetSurveys">Get Surveys</Link></li>
                </ul>
              </li>
            }
            {/**
              * Partner Account — a different application on its own domain, not
              * a route in this one.
              *
              * A plain anchor rather than a react-router Link, because Link
              * would try to resolve it as an in-app path. `rel="noopener"` is
              * required alongside `target="_blank"`: without it the opened page
              * gets a handle on this window through `window.opener` and can
              * navigate it elsewhere.
              */}
            {restoToken &&
              <a
                className='Link'
                href="https://partner.way-trix.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <li className="drawer-menu-item">
                  <span className="dropdown-toggle aTitle">Partner Account</span>
                </li>
              </a>
            }
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
